import React from 'react'
import { Box, Chip, IconButton, Paper, Stack } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import ChangeHistoryIcon from '@mui/icons-material/ChangeHistory'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import { grey } from '@mui/material/colors'
import { useGlobalState } from 'state'
import { ObservatoryRow, ObservatoryType } from 'common/types'
import { StageMonitor } from './StageMonitor'
import { RainMonitor } from './RainMonitor'


type MonitorContainerProps = {
  width: number
}

const targetStages = [
  '5633_34',
  '5633_39',
  '5633_36',
  '99_22000_4_26',
  '5633_33',
  '5633_40',
  '5633_123',
  '99_22000_4_2',
  '99_22000_4_1',
  '99_22000_4_3',
  '5633_37',
  '5633_38',
  '5633_122',
  '5633_125',
  '99_22000_4_27',
  '99_22000_4_28',
  '21827_3',
  '21827_1',
  '5633_146',
  '5633_32',
  '21827_2',
  '5633_35',
  '5633_124',
  '5633_31',
  '5633_42',
  '5633_41',
  '5633_145',
  '5633_30',
  '99_22000_4_31',
  '99_22000_4_30',
  '99_22000_4_24',
  '99_22000_4_23',
  '99_22000_4_25',
  '99_22000_4_29',
  '21335_10',
  '21335_11',
  '21335_12'
]

const targetRains = [
  '30000_50331',
  '5633_57',
  '5633_59',
  '5633_58',
  '5633_61',
  '5633_63',
  '5633_109',
  '5633_55',
  '30000_50261',
  '5633_65',
  '5633_52',
  '5633_51',
  '5633_62',
  '21827_7',
  '21827_4',
  '5633_60',
  '21827_2',
  '21827_3',
  '21827_6',
  '5633_56',
  '30000_50247',
  '21827_39',
  '30000_50112',
  '21827_20',
  '21827_42',
  '5633_53',
  '21827_38',
  '21827_40',
  '21827_8',
  '21827_1',
  '21827_5',
  '5633_66',
  '5633_54',
  '21827_21',
  '21827_19',
  '5633_64',
  '21827_18',
]

export const MonitorContainer = ({width}: MonitorContainerProps) => {
  const state = useGlobalState()
  const [stages, setStages] = React.useState<ObservatoryRow[]>([])
  const [rains, setRains] = React.useState<ObservatoryRow[]>([])

  React.useEffect(() => {
    setStages(targetStages
      .map(id => {
        const obs = state.observatories.find(obs => obs.type === ObservatoryType.Stage && obs.id === id)
        return obs ? obs : null
      })
      .filter(obs => obs !== null) as ObservatoryRow[]
    )

    setRains(
      targetRains
        .map(id => {
          const obs = state.observatories.find(obs => obs.type === ObservatoryType.Rain && obs.id === id)
          return obs ? obs : null
        })
        .filter(obs => obs !== null) as ObservatoryRow[]
    )
  }, [state.observatories])

  return (
    <Box sx={{borderLeft: '1px solid #9e9e9e'}}>
      <Paper sx={{width, backgroundColor: grey[50], height: '100dvh'}} elevation={0} square>
        <Stack direction="row" justifyContent="end" sx={{height: 35}}>
          <IconButton size='small' onClick={() => state.app.setMonitorContainer('none')}>
            <CloseIcon sx={{color: grey[500]}} fontSize='small' />
          </IconButton>
        </Stack>
        <Stack direction="column" justifyContent="flex-start" padding={1} spacing={1} sx={{height: 'calc(100dvh - 40px)'}}>
          <Box>
            <Chip size='small' sx={{p: 1}} icon={<ChangeHistoryIcon />} label="水位モニタリング" />
          </Box>
          <StageMonitor height={'calc(50dvh - 70px)'} stages={stages} />
          <Box>
            <Chip size='small' sx={{p: 1}} icon={<RadioButtonUncheckedIcon />} label="雨量モニタリング" />
          </Box>
          <RainMonitor height={'calc(50dvh - 70px)'} rains={rains} />
        </Stack>
      </Paper>
    </Box>
  )
}
